import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  GithubConnectionTestResult,
  GithubProjectConfig,
  SaveGithubRepoUrlRequest,
} from '../models/github-project-config.model';

@Injectable({ providedIn: 'root' })
export class GithubProjectService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<GithubProjectConfig[]> {
    return this.http.get<GithubProjectConfig[]>(`${this.base}/${projectId}/github`);
  }

  create(projectId: string, repoUrl: string): Observable<GithubProjectConfig> {
    const body: SaveGithubRepoUrlRequest = { repoUrl };
    return this.http.post<GithubProjectConfig>(`${this.base}/${projectId}/github`, body);
  }

  update(projectId: string, id: string, repoUrl: string): Observable<GithubProjectConfig> {
    const body: SaveGithubRepoUrlRequest = { repoUrl };
    return this.http.patch<GithubProjectConfig>(`${this.base}/${projectId}/github/${id}`, body);
  }

  delete(projectId: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${projectId}/github/${id}`);
  }

  testConnection(projectId: string, id: string): Observable<GithubConnectionTestResult> {
    return this.http
      .post<{
        success: boolean;
        ownerLogin?: string;
        repoName?: string;
        defaultBranch?: string;
      }>(`${this.base}/${projectId}/github/${id}/test-connection`, null)
      .pipe(
        map((res) => ({
          success: res.success,
          ownerLogin: res.ownerLogin,
          repoName: res.repoName,
          defaultBranch: res.defaultBranch,
        })),
        catchError((err: HttpErrorResponse) => {
          const code = err.error?.code as GithubConnectionTestResult['errorCode'] | undefined;
          return of<GithubConnectionTestResult>({
            success: false,
            errorCode: code ?? 'GENERIC',
          });
        }),
      );
  }
}
